export default __webpack_public_path__ + "55178a1bdbbc81c2a7204d35ce8475f0.png";